var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4130_213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 48,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.85664H48V41.1424H0V6.85664Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4130_213)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0256 24.3894H1.55859V31.8064H8.80011C12.6751 31.8064 15.8384 28.5229 16.0256 24.3867",
    fill: "#6DBE50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.80011 16.1918H1.55859V23.6114H16.0336C15.8389 19.4752 12.6724 16.1918 8.79877 16.1918",
    fill: "#6DBE50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2081 16.1918C35.3331 16.1918 32.1618 19.4828 31.9746 23.6114H46.4335C46.2539 19.4752 43.0817 16.1918 39.2068 16.1918",
    fill: "#6DBE50"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4402 24.3894H31.9746C32.1618 28.5263 35.3249 31.8064 39.2081 31.8064C43.0913 31.8064 46.2544 28.5229 46.4416 24.3867",
    fill: "#6DBE50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.7602 16.1918V24.0012C16.7602 28.184 19.8042 31.6002 23.6414 31.8025V16.1918H16.7602Z",
    fill: "#6DBE50"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2402 16.1918H24.3656V31.8106H31.2402V16.1918Z",
    fill: "#6DBE50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuo);
export default __webpack_public_path__ + "static/media/Duo.b2489cc89cadfc5206e207a213dc451f.svg";
export { ForwardRef as ReactComponent };